import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import GradeIcon from "@mui/icons-material/Grade";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { addProductImg } from "../../Reducers/authReducer";
import { useGetUserDataQuery } from "../../services/login";
import formatPrice from "../formatPrice";
import ProductCountries from "../Header/ProductCountries";
var moment = require("moment");

const CAROUSEL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

  .hpc-section { margin-bottom: 28px; font-family: 'DM Sans', 'Segoe UI', sans-serif; }

  .hpc-heading {
    font-size: 1.05rem;
    font-weight: 700;
    color: #111;
    margin: 0 0 12px 6px;
    letter-spacing: -0.01em;
  }

  /* ── Scroll container ── */
  .hpc-scroll-wrap { position: relative; }

  .hpc-scroll-track {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 4px 4px 10px;
    scrollbar-width: none;
  }
  .hpc-scroll-track::-webkit-scrollbar { display: none; }

  /* ── Nav arrows (desktop only) ── */
  .hpc-arrow {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-60%);
    z-index: 10;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
    transition: box-shadow 0.15s, background 0.15s;
    color: #333;
  }
  .hpc-arrow:hover { background: #f5f5f5; box-shadow: 0 4px 14px rgba(0,0,0,0.13); }
  .hpc-arrow-left  { left: -16px; }
  .hpc-arrow-right { right: -16px; }

  /* ── Card ── */
  .hpc-card-link { text-decoration: none; color: inherit; flex-shrink: 0; }

  .hpc-card {
    width: 170px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    background: #fff;
    overflow: hidden;
    scroll-snap-align: start;
    transition: box-shadow 0.2s, transform 0.2s;
    display: flex;
    flex-direction: column;
  }
  .hpc-card:hover {
    box-shadow: 0 6px 22px rgba(0,0,0,0.10);
    transform: translateY(-2px);
  }

  .hpc-img-wrap {
    position: relative;
    width: 100%;
    height: 155px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff0;
    padding: 10px;
    overflow: hidden;
  }
  .hpc-img-wrap img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .hpc-body {
    padding: 9px 10px 11px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .hpc-title {
    font-size: 13px;
    font-weight: 500;
    color: #222;
    line-height: 1.35;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 34px;
  }

  .hpc-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    margin-top: 2px;
  }

  .hpc-brand {
    font-size: 0.68rem;
    color: #aaa;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60%;
  }

  .hpc-rating {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 0.68rem;
    font-weight: 600;
    color: #666;
    background: #fff8f2;
    border: 1px solid #ffe4cc;
    border-radius: 20px;
    padding: 2px 6px;
    white-space: nowrap;
  }

  .hpc-price-row {
    display: flex;
    align-items: baseline;
    gap: 5px;
    flex-wrap: wrap;
    margin-top: 3px;
  }

  .hpc-deal-price {
    font-size: 0.92rem;
    font-weight: 700;
    color: #111;
    line-height: 1.2;
  }

  .hpc-orig-price {
    font-size: 0.7rem;
    color: #bbb;
    text-decoration: line-through;
  }

  .hpc-origin {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: auto;
    padding-top: 5px;
  }

  .hpc-from { font-size: 0.67rem; color: #bbb; }
  .hpc-flag { width: 15px; object-fit: contain; }

  .hpc-deal-badge {
    position: absolute;
    top: 7px; left: 7px;
    background: #ff4757;
    color: #fff;
    font-size: 0.58rem;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;
    z-index: 2;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .hpc-flash-badge {
    position: absolute;
    top: 7px; right: 7px;
    background: #ff4757;
    color: #fff;
    border-radius: 50%;
    width: 22px; height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .hpc-delivery {
    font-size: 0.62rem;
    color: #888;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ── Show arrows on desktop ── */
  @media (min-width: 769px) {
    .hpc-arrow { display: flex; }
    .hpc-card { width: 225px; }
    .hpc-img-wrap { height: 165px; }
  }

  /* ── Mobile card sizing ── */
  @media (max-width: 768px) {
    .hpc-card { width: 145px; }
    .hpc-img-wrap { height: 130px; padding: 8px; }
    .hpc-scroll-track { gap: 9px; }
  }

  @media (max-width: 380px) {
    .hpc-card { width: 130px; }
    .hpc-img-wrap { height: 115px; }
  }

  /* ── Skeleton ── */
  @keyframes hpc-shimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  .hpc-skel {
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: hpc-shimmer 1.4s infinite;
    border-radius: 6px;
  }
`;

const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12];

function functionIdLink(id, pid, store_id) {
  return storeIds?.includes(Number(store_id)) ? pid : id;
}

function productTitle(title) {
  return title
    ?.replace(/[^A-Za-z0-9]/g, " ")
    ?.replace(/[^\w\s]/gi, " ")
    ?.replace(/ /g, "-");
}

const handleImgError = (e) => {
  e.target.src = "https://cdn.ebtida.com/1705315901965-Image-not-found.jpg";
};

function CarouselSkeleton() {
  return (
    <div className="hpc-scroll-track" style={{ pointerEvents: "none" }}>
      {[...Array(6)].map((_, i) => (
        <div key={i} className="hpc-card" style={{ flexShrink: 0 }}>
          <div className="hpc-skel" style={{ width: "100%", height: 155 }} />
          <div style={{ padding: "10px 10px 12px", display: "flex", flexDirection: "column", gap: 6 }}>
            <div className="hpc-skel" style={{ height: 10, width: "90%" }} />
            <div className="hpc-skel" style={{ height: 10, width: "60%" }} />
            <div className="hpc-skel" style={{ height: 12, width: "45%", marginTop: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

function ProductCard({ item, languageCode, getDeliverydays, addProductImage }) {
  const { t } = useTranslation();

  return (
    <Link
      className="hpc-card-link"
      to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(
        item?.id,
        item?.pid,
        item?.store_id
      )}/${productTitle(item?.title)}?country=${item?.country}`}
      onClick={() => addProductImage(item?.image)}
    >
      <div className="hpc-card">
        <div className="hpc-img-wrap">
          {item?.prices?.deal_value && (
            <div className="hpc-flash-badge">
              <FlashOnIcon style={{ fontSize: "0.75rem" }} />
            </div>
          )}
          <img src={item?.image} alt={item?.title} onError={handleImgError} />
        </div>

        <div className="hpc-body">
          <h4 className="hpc-title">{item?.title?.replace(/[^\w\s.,'/:]/gi, " ")}</h4>

          <div className="hpc-meta">
            {item?.brand && <span className="hpc-brand">{item?.brand}</span>}
            {item?.rating && Number(item?.rating) > 0 && (
              <span className="hpc-rating">
                {item?.rating}
                <GradeIcon style={{ fontSize: "0.65rem", color: "#fe7f4a" }} />
              </span>
            )}
          </div>

          <div className="hpc-price-row">
            {Number(item?.prices?.value) === 0 ? (
              <span
                style={{
                  fontSize: "0.7rem",
                  background: "#f0f0f0",
                  color: "#666",
                  padding: "2px 7px",
                  borderRadius: 4,
                  fontWeight: 500,
                }}
              >
                Check Price
              </span>
            ) : (
              <>
                <span className="hpc-deal-price">{formatPrice(item?.prices?.value, item?.prices?.currency, 0)}</span>
                {item?.prices?.deal_value && (
                  <span className="hpc-orig-price">{formatPrice(item?.prices?.price, item?.prices?.currency, 0)}</span>
                )}
              </>
            )}
          </div>

          <div className="hpc-origin">
            <span className="hpc-from">{t("from") || "From"}</span>
            <img
              className="hpc-flag"
              loading="lazy"
              src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
              srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
              alt=""
            />
            <span className="hpc-from">{ProductCountries(item?.country)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

function HomeProductCards({ productData, heading, isLoading }) {
  const { t } = useTranslation();
  const { userId, userToken, languageCode, countryCode } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const listRef = useRef(null);

  const { data: userData } = useGetUserDataQuery(
    { userId, userToken, countryCode },
    { count: 1, refetchOnMountOrArgChange: true }
  );

  function addProductImage(data) {
    dispatch(addProductImg({ productImg: data }));
  }

  function getDeliverydays(delivery) {
    const days = Number(delivery) + Number(userData?.contant?.delivery_days || 0);
    if (days <= 0) return `${t("delivery_by")} ${moment().add(10, "days").format("Do MMM")}`;
    if (days === 1) {
      return (
        <>
          {t("delivery_by")} <strong>{t("tomorrow")}</strong> {moment().add(1, "days").format("Do")}
        </>
      );
    }
    return `${t("delivery_by")} ${moment().add(days, "days").format("Do MMM")}`;
  }

  function handleScroll(dir) {
    if (!listRef.current) return;
    const itemW = listRef.current.scrollWidth / (productData?.length || 1);
    listRef.current.scrollBy({
      left: dir === "next" ? itemW * 4 : -itemW * 4,
      behavior: "smooth",
    });
  }

  if (!productData?.length && !isLoading) return null;

  return (
    <div className="hpc-section">
      <style>{CAROUSEL_STYLES}</style>

      {heading && (
        <div
          className="hpc-heading"
          style={{
            fontSize: "0.9rem",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "#6b6b6b",
          }}
        >
          {heading}
        </div>
      )}

      {isLoading ? (
        <CarouselSkeleton />
      ) : (
        <div className="hpc-scroll-wrap">
          {productData?.length > 4 && (
            <button className="hpc-arrow hpc-arrow-left" onClick={() => handleScroll("prev")} aria-label="Scroll left">
              <ChevronLeftIcon style={{ fontSize: "1.1rem" }} />
            </button>
          )}

          <div className="hpc-scroll-track" ref={listRef}>
            {productData?.map((item, i) => (
              <ProductCard
                key={item?.id || i}
                item={item}
                languageCode={languageCode}
                getDeliverydays={getDeliverydays}
                addProductImage={addProductImage}
              />
            ))}
          </div>

          {productData?.length > 4 && (
            <button
              className="hpc-arrow hpc-arrow-right"
              onClick={() => handleScroll("next")}
              aria-label="Scroll right"
            >
              <ChevronRightIcon style={{ fontSize: "1.1rem" }} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default HomeProductCards;
